import { MAX_PARTNERS_BY_DRAFTS } from 'constants/defaultConstants';
import { getStockPlans } from 'modules/beneficiaries/redux/planActions';
import { useGetPartners } from 'modules/partners/hooks/useGetPartners';
import { getHoldingClasses } from 'modules/partners/redux/holdingClassActions';
import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { State } from 'redux/initialState';
import { useGetActualSociety } from 'hooks/useGetActualSociety';
import { getDrafts } from '../redux/draftActions';

type UseDraftCapitalIncreaseProps = {
  societyId: string;
};

const useDraftCapitalIncrease = ({
  societyId,
}: UseDraftCapitalIncreaseProps) => {
  const dispatch = useDispatch();

  const actualSociety = useSelector(
    (state: State) => state?.society?.actualSociety
  );
  const drafts = useSelector((state: State) => state?.drafts);
  const holdingClasses = useSelector((state: State) => state?.holdingClasses);
  const operations = useSelector((state: State) => state?.operations);
  const partners = useSelector((state: State) => state?.partners);
  const plans = useSelector((state: State) => state?.plans);

  useGetActualSociety(societyId);

  useGetPartners({
    societyId,
    partnerId: '',
    categoryId: '',
    page: 1,
    items: MAX_PARTNERS_BY_DRAFTS,
  });

  const planUnits = useMemo(
    () =>
      plans
        ?.filter((plan) => !plan?.isDraft)
        ?.reduce((acc, plan) => acc + plan?.sharesTotal, 0),
    [plans]
  );

  useEffect(() => {
    if (societyId) {
      dispatch(getHoldingClasses({ societyId }));
      dispatch(getStockPlans(societyId));
    }
  }, [societyId]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (societyId) {
      dispatch(getDrafts(societyId));
    }
  }, [societyId]); // eslint-disable-line react-hooks/exhaustive-deps

  return {
    data: {
      actualSociety,
      drafts,
      plans,
      holdingClasses,
      operations,
      partners,
      planUnits,
    },
    isLoading: false,
    isError: false,
  };
};

export default useDraftCapitalIncrease;
